import { appSettings } from "../../../../../apps/services/config";

const url = appSettings.vms_url;

export const connection = {
    'DEPLOY_URL': url,
}

export default connection;